export default class Url {
  /**
   * @param {string} name
   * @return {string|null}
   */
  static getParam(name) {
    const urlSearchParams = new window.URLSearchParams(window.location.search);

    if (urlSearchParams.has(name)) {
      return urlSearchParams.get(name).trim() || null;
    }

    return null;
  }
}
